import { defineMessages } from "react-intl";

export const common = defineMessages({
  yes: { id: "generic.common.yes", defaultMessage: "Oui" },
  no: { id: "generic.common.no", defaultMessage: "Non" },
  countedRooms: { id: "generic.common.counted-rooms", defaultMessage: "{count, plural, =1 {pièce} other {pièces}}" },
  countedBedrooms: { id: "generic.common.counted-bedrooms", defaultMessage: "{count, plural, =1 {chambre} other {chambres}}" },
  countedGuests: { id: "generic.common.counted-guests", defaultMessage: "{count, plural, =1 {personne} other {personnes}}" },
  limitedGuests: { id: "generic.common.limited-guests", defaultMessage: "{format, select, single {{count} personne} max {{max}+ personnes} other {{count} personnes}}" }
});

export const pricing = defineMessages({
  price: { id: "generic.prices.price", defaultMessage: "Prix" },
  unit: { id: "generic.prices.unit", defaultMessage: "Prix unitaire" },
  amount: { id: "generic.prices.amount", defaultMessage: "Montant" },
  discount: { id: "generic.prices.discount", defaultMessage: "Réduction" },
  total: { id: "generic.prices.total", defaultMessage: "Total" },
  detailed: { id: "generic.prices.detailed", defaultMessage: "Détail du prix" },
  onDemand: { id: "generic.prices.on-demand", defaultMessage: "Prix sur demande" },
  onDemandShort: { id: "generic.prices.on-demand-short", defaultMessage: "Sur demande" },
  lowest: { id: "generic.prices.lowest", defaultMessage: "Dès {price} par {type, select, DAILY {nuit} other {semaine}}"},
  byNight: { id: "generic.prices.by-night", defaultMessage: "{price} par nuitée" },
  byWeek: { id: "generic.prices.by-week", defaultMessage: "Dès {price} par semaine" },
  byMonth: { id: "generic.prices.by-month", defaultMessage: "{price} par mois" },
  down: { id: "generic.prices.down-payment", defaultMessage: "Acompte" },
  chargeLabel: { id: "generic.prices.charge-label", defaultMessage: "Frais de service" },
  charge: { id: "generic.prices.charge", defaultMessage: "{adaptive, select, true {jusqu'à } other {}}{amount}" },
  taxes: { id: "generic.prices.taxes", defaultMessage: "Taxes de séjour" }
});

export const booking = defineMessages({
  checkIn: { id: "generic.booking.check-in", defaultMessage: "Arrivée" },
  checkOut: { id: "generic.booking.check-out", defaultMessage: "Départ" },
  period: { id: "generic.booking.period", defaultMessage: "Période" },
  nights: { id: "generic.booking.nights", defaultMessage: "{count, plural, =1 {une nuit} other {# nuits}}" },
});

export const actions = defineMessages({
  login: { id: "generic.actions.login", defaultMessage: "Se connecter" },
  logout: { id: "generic.actions.logout", defaultMessage: "Se déconnecter" },
  register: { id: "generic.actions.register", defaultMessage: "S'inscrire" },
  refresh: { id: "generic.actions.refresh", defaultMessage: "Rafraîchir" },
  remove: { id: "generic.actions.remove", defaultMessage: "Supprimer" },
  continue: { id: "generic.actions.continue", defaultMessage: "Continuer" },
  back: { id: "generic.actions.back", defaultMessage: "Retour" },
  backHome: { id: "generic.actions.back-home", defaultMessage: "Retour à la page d'accueil" },
  send: { id: "generic.actions.send", defaultMessage: "Envoyer" },
  contact: { id: "generic.actions.contact", defaultMessage: "Contacter" },
  book: { id: "generic.actions.book", defaultMessage: "Réserver" },
  close: { id: "generic.actions.close", defaultMessage: "Fermer" },
  validate: { id: "generic.actions.validate", defaultMessage: "Valider" },
  save: { id: "generic.actions.save", defaultMessage: "Enregistrer" },
  showMap: { id: "generic.actions.map-show", defaultMessage: "Voir la carte" },
  showList: { id: "generic.actions.list-show", defaultMessage: "Voir la liste" },
  search: { id: "generic.actions.search", defaultMessage: "Rechercher" },
  reset: { id: "generic.actions.reset", defaultMessage: "Réinitialiser" }
});

export const form = defineMessages({
  firstName: { id: "generic.form.firstName", defaultMessage: "Prénom" },
  lastName: { id: "generic.form.lastName", defaultMessage: "Nom" },
  email: { id: "generic.form.email", defaultMessage: "E-mail" },
  phone: { id: "generic.form.phone", defaultMessage: "Téléphone" },
  street: { id: "generic.form.street", defaultMessage: "Rue" },
  streetNumber: { id: "generic.form.streetNumber", defaultMessage: "N°" },
  streetComplement: { id: "generic.form.streetComplement", defaultMessage: "Adresse complémentaire" },
  zip: { id: "generic.form.zip", defaultMessage: "NPA" },
  city: { id: "generic.form.city", defaultMessage: "Localité" },
  country: { id: "generic.form.country", defaultMessage: "Pays" },
  countryPlaceholder: { id: "generic.form.country-placeholder", defaultMessage: "Sélectionnez un pays" },
  msg: { id: "generic.form.msg", defaultMessage: "Message" },
  msgPlaceholder: { id: "generic.form.msg-placeholder", defaultMessage: "Dites-nous comment nous pouvons vous aider." },
  datePlaceholder: { id: "generic.form.date-placeholder", defaultMessage: "Ajouter des dates" },
  guests: { id: "generic.form.guests", defaultMessage: "Participants" },
  guestsPlaceholder: { id: "generic.form.guests-placeholder", defaultMessage: "Ajouter des participants" },
  emptyError: { id: "generic.form.errors.empty", defaultMessage: "Cette information est requise" },
  emailError: { id: "generic.form.errors.email", defaultMessage: "Cet e-mail n'est pas valide" },
  phoneError: { id: "generic.form.errors.phone", defaultMessage: "Ce numéro n'est pas valide. Respectez le format international (+41 xx xxx xx xx)" },
  minError: { id: "generic.form.errors.min", defaultMessage: "Doit contenir au moins {min} caractères" },
  sent: { id: "generic.form.sent", defaultMessage: "Votre message a été envoyé avec succès" },
  failed: { id: "generic.form.failed", defaultMessage: "Une erreur est survenue à l'envoi" }
});

export const article = defineMessages({
  language: { id: "article.description-language", defaultMessage: "Cette information n'est pas disponible dans votre langue." },
  surface: { id: "generic.article.surface", defaultMessage: "Surface" },
  rooms: { id: "generic.article.rooms", defaultMessage: "Pièces" },
  roomRooms: { id: "generic.article.rooms-whole", defaultMessage: "Ensemble" },
  bedrooms: { id: "generic.article.bedrooms", defaultMessage: "Chambres" },
  bathrooms: { id: "generic.article.bathrooms", defaultMessage: "Salles de bains" },
  equipment: { id: "generic.article.equipment", defaultMessage: "Équipements" },
  cityCenter: { id: "generic.article.features.city-center", defaultMessage: "Proche du centre" },
  shoppingArea: { id: "generic.article.features.shopping-area", defaultMessage: "Sur rue commerçante" },
  skiArea: { id: "generic.article.features.ski-area", defaultMessage: "À proximité des remontées" },
  busStop: { id: "generic.article.features.bus-stop", defaultMessage: "Proche des transports en commun" },
  clearView: { id: "generic.article.features.clear-view", defaultMessage: "Vue dégagée" },
  parking: { id: "generic.article.features.parking", defaultMessage: "Parking" },
  lift: { id: "generic.article.features.lift", defaultMessage: "Ascenseur" },
  balcony: { id: "generic.article.features.balcony", defaultMessage: "Balcon" },
  terrace: { id: "generic.article.features.terrace", defaultMessage: "Terrasse" },
  pool: { id: "generic.article.features.pool", defaultMessage: "Piscine" },
  sauna: { id: "generic.article.features.sauna", defaultMessage: "Sauna" },
  fireplace: { id: "generic.article.features.fireplace", defaultMessage: "Cheminée" },
  dishwasher: { id: "generic.article.features.dishwasher", defaultMessage: "Lave-vaisselle" },
  washingMachine: { id: "generic.article.features.washing-machine", defaultMessage: "Lave-linge" },
  tv: { id: "generic.article.features.tv", defaultMessage: "TV" },
  wifi: { id: "generic.article.features.wifi", defaultMessage: "WIFI" },
  microwave: { id: "generic.article.features.microwave", defaultMessage: "Micro-onde" },
  oven: { id: "generic.article.features.oven", defaultMessage: "Four" },
  smoker: { id: "generic.article.features.smoker", defaultMessage: "Non-fumeur" },
  pet: { id: "generic.article.features.pet", defaultMessage: "Animaux admis" },
  no_pet: { id: "generic.article.features.no-pet", defaultMessage: "Animaux non admis" },
  disabledPerson: { id: "generic.article.features.disabled-person", defaultMessage: "Accès pour personnes handicapées" },
  new: { id: "generic.article.features.new", defaultMessage: "Neuf" },
  furnished: { id: "generic.article.features.furnished", defaultMessage: "Meublé" },
  secondaryHome: { id: "generic.article.features.secondary-home", defaultMessage: "Résidence secondaire" },
  forForeigners: { id: "generic.article.features.for-foreigners", defaultMessage: "Disponible aux non-résidants" },
  orientation: { id: "generic.article.features.orientation", defaultMessage: "Orientation" },
  heater: { id: "generic.article.features.heater", defaultMessage: "Chauffage" },
  renovation_fund: { id: "generic.article.features.renovation_fund", defaultMessage: "Fonds de rénovation" },
  charge: { id: "generic.article.features.charge", defaultMessage: "Charge" },
  wc: { id: "generic.article.features.wc", defaultMessage: "WC" },
  free_parking: { id: "generic.article.features.free-parking", defaultMessage: "Parking gratuit sur place" },
  non_smoker: { id: "generic.article.features.non-smoker", defaultMessage: "Non fumeur" },
});

export const menu_translations = defineMessages({
  home: { id: "generic.menu.home", defaultMessage: "Accueil" },
  rental: { id: "generic.menu.main-rental", defaultMessage: "Locations" },
  services: { id: "generic.menu.services", defaultMessage: "Services" },
  management: { id: "generic.menu.management", defaultMessage: "Gérance" },
  estimation: { id: "generic.menu.estimation", defaultMessage: "Estimation immobilière" },
  renovation: { id: "generic.menu.renovation", defaultMessage: "Rénovation" },
  agency: { id: "generic.menu.agency", defaultMessage: "Agence" },
  about: { id: "generic.menu.about", defaultMessage: "À propos" },
  nendaz: { id: "generic.menu.nendaz", defaultMessage: "Nendaz" },
  news: { id: "generic.menu.news", defaultMessage: "Actualités" },
  contact: { id: "generic.menu.contact", defaultMessage: "Contact" },
  profile: { id: "generic.menu.profile", defaultMessage: "Mon profil" },
  legal_notice: { id: "generic.menu.legal-notice", defaultMessage: "Mentions légales" },
  privacy_policy: { id: "generic.menu.privacy-policy", defaultMessage: "Politiques de confidentialité" }
});

export const card = defineMessages({
  novelty: { id: "cards.tags.novelty", defaultMessage: "Nouveauté" },
  recommended: { id: "cards.tags.recommended", defaultMessage: "Coup de coeur" },
  sold: { id: "cards.tags.sold", defaultMessage: "Vendu" },
  added_wishlist_title: { id: "cards.added-wishlist.title", defaultMessage: "Coup de cœur enregistré !" },
  added_wishlist: { id: "cards.added-wishlist", defaultMessage: "Le produit a été ajouté à votre liste d'envie !" },
  removed_wishlist_title: { id: "cards.removed-wishlist.title", defaultMessage: "C'est noté !" },
  removed_wishlist: { id: "cards.removed-wishlist", defaultMessage: "Le produit a été retiré de votre liste d'envie !" }
});
